import photo1 from './photos/01.jpg';
import photo2 from './photos/02.jpg';
import photo3 from './photos/03.jpg';

const Deta = [
    {
        id:1,
        imge: photo1,
        title: 'Rainbow Vegetable Sandwich',
        time: 'Time: 15 - 20 Minutes | Serves: 1',
        price: '$10.50',
    },{
        id:2,
        imge: photo2,
        title: 'Vegetarian Burger',
        time: 'Time: 30 - 45 Minutes | Serves: 1',
        price: '$9.20'
    },{
        id:3,
        imge: photo3,
        title: 'Raspberry Stuffed French Toast',
        time: 'Time: 10 - 15 Minutes | Serves: 1',
        price: '$12.50'
    }
]
export default Deta;